'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.values = exports.SECUSIGN = exports.ICA = exports.HSM = exports.MARBES = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:40:46Z                      #

// ##############################################################


var MARBES = exports.MARBES = 'MARBES';

var HSM = exports.HSM = 'HSM';

var ICA = exports.ICA = 'ICA';

var SECUSIGN = exports.SECUSIGN = 'SECUSIGN';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [MARBES, HSM, ICA, SECUSIGN];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, MARBES, { caption: '' }), (0, _defineProperty3.default)(_params, HSM, { caption: '' }), (0, _defineProperty3.default)(_params, ICA, { caption: '' }), (0, _defineProperty3.default)(_params, SECUSIGN, { caption: '' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
    return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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